/**
 *
 * RoleHeader
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Card, Alert } from 'react-bootstrap';
import UploadAvatar from 'components/user/UploadAvatar/index.jsx';
import Form4SingleField from 'components/interaction/Form4/Form4SingleField.jsx';
import UserText from 'components/media/UserText/Loadable.js';
import { FormattedMessage } from 'react-intl';
import messages from './messages.js';

function RoleHeader(props) {
  const { schoolRole, onChange } = props;

  function handleChangeAvatar(val) {
    return val ? onChange('newAvatar', val) : onChange('avatar', null);
  }

  const itemToString = (val) => <UserText className="fs-4 fw-semibold">{val}</UserText>;
  return (
    <Card.Header className="border-0 text-center pt-5">
      <div className="mb-4">
        <UploadAvatar value={schoolRole.avatar} onChange={handleChangeAvatar} />
      </div>
      <Form4SingleField
        value={schoolRole.name || schoolRole.displayName}
        options={{ id: 'name', type: 'text', required: true, itemToString }}
        onChange={onChange}
        inline
      />
      {schoolRole.systemType && (
        <Alert variant="info" className="px-sm-5"><FormattedMessage {...messages.standardRoleIntro} values={schoolRole} /></Alert>
      )}
    </Card.Header>
  );
}

RoleHeader.propTypes = {
  onChange: PropTypes.func,
  schoolRole: PropTypes.object,
};

export default RoleHeader;
